import { render, staticRenderFns } from "./owners.vue?vue&type=template&id=e79f674c&scoped=true&"
import script from "./owners.vue?vue&type=script&lang=js&"
export * from "./owners.vue?vue&type=script&lang=js&"
import style0 from "./owners.vue?vue&type=style&index=0&id=e79f674c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79f674c",
  null
  
)

export default component.exports